module.exports = __webpack_public_path__ + "media/newstyle/images/icon-check-pink-bab4a614d6f02ab5e0c538b2ff8cc938.svg";